export const SET_PHASE = "SET_PHASE";
export const SET_OPTIONS = "SET_OPTIONS";
export const SET_SELECTED = "SET_SELECTED";
export const TOGGLE_SECTION = "TOGGLE_SECTION";
export const SET_ERROR = "SET_ERROR";
export const SET_RESULT = "SET_RESULT";
export const RESET_BACKUP = "RESET_BACKUP";
export const SET_LAST_BACKUP_TIME = "SET_LAST_BACKUP_TIME";
